
<div class="details-sub-div" *ngFor="let link of links">
    <a href="#" (click)="navigateExternal(link)" class="text-details" *ngIf="link.external">{{link.name}}</a>
    <a href="#" [routerLink]="['/view/' + link.id]" target="_blank" class="text-details" *ngIf="!link.external">{{link.name}}</a>
</div>
